import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Stack,
  TextField,
  InputAdornment,
  Divider,
} from "@mui/material";

import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import CustomButton from "../components/CustomButton";
import TopBar from "../components/TopBar";

import { useParams } from "react-router-dom";

import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";

import '../styles/ActivateSchwits.css'

const API_URL = process.env.REACT_APP_API_URL

const EventSettings = () => {
  const navigate = useNavigate();
  const [eventName, setEventName] = useState("");
  const [eventActive, setEventActive] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [eventDate, setEventDate] = useState("");
  const [user, setUser] = useState({});
  const [currentEvent, setCurrentEvent] = useState();
  const [totalAmount, setTotalAmount] = useState();
  const [paymentsAllowed, setPaymentsAllowed] = useState(false);

  const [minAmount, setMinAmount] = useState();


	const { eventId } = useParams();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
      } else {
        setUser(currentUser)
        navigate('/Login')
      }
    })

    return () => unsubscribe()
  }, [])

	useEffect(() => {
    const getEvent = async () => {
      await fetch(`${API_URL}/firebase/get-event`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          eventId: eventId,
        })
      }).then((res) => res.json())
      .then((res) => {
        setCurrentEvent(res)
				setEventDate(res.Date)
				setEventName(res.Name)
				setMinAmount(res.MinAmount)
				setEventActive(res.Active)
        setTotalAmount(res.totalAmount)
        setPaymentsAllowed(res.PaymentsAllowed)
      })
    }
    getEvent();
  }, [eventId])


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const clearInput = (inputField) => {
    setEventName("");
  };

  const updateEvent = () => {
    if(user && user.email) {
      const formData = new FormData();
      formData.append('userEmail', user.email);
      formData.append('eventName', eventName);
      formData.append('eventDate', eventDate);
      formData.append('eventId', eventId);
      formData.append('minimumAmount', minAmount);
      formData.append('activateEvent', eventActive);
      formData.append('paymentsAllowed', paymentsAllowed);
      if (selectedFile){
        formData.append('file', selectedFile);
      }
      try {
        fetch(`${API_URL}/firebase/update-event`, {
          method: 'POST',
          body: formData
        }).then((res) => {
          if(res.status === 400){
            alert("Set all event parameters")
          } else {
            navigate(`/Events/${eventId}`)
          }
        })
      } catch (e) {
        console.log(e)
      }
    }
  }

  const handleDeleteEvent = async() => {
    const userConfirmed = window.confirm(`Restoring deleted events is not possible. Delete "${currentEvent.Name}"?`);
    if (userConfirmed) {
      await fetch(`${API_URL}/firebase/delete-event`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          eventId: eventId,
        }),
      }).then(() => {
        navigate("/dashboard")
      })
    }
  }

  return (
    <Box className="max_container" sx = {{ marginTop: 8 }}>
      <TopBar />
      <Divider color="gray" width="100%" sx = {{ marginTop: 4, marginBottom: 4 }}/>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h3 className="text-2px uppercase font-medium text-white">Total amount: ${totalAmount}</h3>
        <button 
            onClick={() => console.log('Withdraw')} 
            style={{
              backgroundColor: '#4CAF90',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer',
              marginLeft: 'auto',
              fontSize: '16px',
              fontWeight: 'bold',
            }}>
            Withdraw
        </button>
      </div>

      <Divider color="gray" width="100%" sx = {{ marginTop: 4, marginBottom: 4 }}/>
			<Box className="mt-5 flex-container" />
				{
					eventActive
					? 
					<p className="text-switch">Current event is active</p>
					:
					<p className="text-switch">Current event is not active</p>
				}
				<label className="switch">
					<input
						type="checkbox"
						checked={eventActive}
						onChange={() => setEventActive(!eventActive)}
					/>
					<span className="slider" />
				</label>
			<Box/>
      <Box className="mt-5 flex-container" />
				{
					paymentsAllowed 
					? 
					<p className="text-switch">Payments are enabled for this Events</p>
					:
					<p className="text-switch">Payments are disabled for this Events</p>
				}
				<label className="switch">
					<input
						type="checkbox"
						checked={paymentsAllowed}
						onChange={() => setPaymentsAllowed(!paymentsAllowed)}
					/>
					<span className="slider" />
				</label>
			<Box/>
      <Box className="mt-10">
        <TextField
          id="input-with-icon-textfield"
          label="Event Name"
          placeholder="input"
          fullWidth
          value={eventName}
          onChange={(e) => setEventName(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <DriveFileRenameOutlineOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("eventName")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </Box>
      <Stack className="bg-gray-500 px-6 mt-8 py-8 rounded-[10px]">
        <p className="text-[#CAC4D0]">Select Date</p>
        <Box className="mt-5">
          <TextField
            id="input-with-icon-textfield"
            label="Date"
            type="date"
            fullWidth
            variant="outlined"
            value={eventDate}
            onChange={(e) => setEventDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </Stack>
			<Box className="mt-5">
        <TextField
          id="input-with-icon-textfield"
          label="Minimum Tip Amount"
          type="number"
          placeholder="input"
          fullWidth
          value={minAmount}
          onChange={(e) => setMinAmount(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AttachMoneyOutlinedIcon />
              </InputAdornment>
            )
            
          }}
          variant="outlined"
        />
      </Box>
      <Box className="mt-5">
        <h3 className="text-2px font-medium text-white">Upload Event Image (optional)</h3>
        <input 
          type="file" 
          id="file-input" 
          accept="image/*"
          onChange={handleFileChange}
        />
      </Box>
      <Stack spacing={2} className="mt-12 px-12">
        <CustomButton 
          myFunction={updateEvent}
          text={"Save Changes"}
        />
				<CustomButton 
          myFunction={() => navigate(`/Events/${eventId}`)}
          text={"Cancel"}
        />
        <CustomButton 
          myFunction={handleDeleteEvent}
          text={"Delete this Event"}
        />
      </Stack>
    </Box>
  );
};

export default EventSettings;
